import { AuthListQueryParam, ListModelItems } from '../models';
import axios from 'axios';
import { IResponseMessages } from '../models/response-messages.model';

export abstract class AuthClient<DataModel, ResponseModel = DataModel> {
    protected constructor(protected basePath: string) {}

    public async getList(
        params: AuthListQueryParam,
        messages?: IResponseMessages,
    ): Promise<ListModelItems<ResponseModel>> {
        const { data } = await axios.get(this.basePath, {
            params,
            errorMessage: messages?.onGetErrorMessage,
        });
        return data;
    }

    public async getOne(id: string, messages?: IResponseMessages): Promise<ResponseModel> {
        const { data } = await axios.get(`${this.basePath}/${id}`, {
            errorMessage: messages?.onGetErrorMessage,
        });
        return data;
    }

    public async createOne(data: DataModel, messages?: IResponseMessages): Promise<ResponseModel> {
        const { data: response } = await axios.post(`${this.basePath}`, data, {
            successMessage: messages?.onCreateSuccessMessage,
            errorMessage: messages?.onCreateErrorMessage,
        });
        return response;
    }

    public async updateOne(id: string, data: DataModel, messages?: IResponseMessages): Promise<ResponseModel> {
        const { data: response } = await axios.put(`${this.basePath}/${id}`, data, {
            successMessage: messages?.onUpdateSuccessMessage,
            errorMessage: messages?.onUpdateErrorMessage,
        });

        return response;
    }

    public async deleteOne(id: string, messages?: IResponseMessages): Promise<void> {
        await axios.delete(`${this.basePath}/${id}`, {
            successMessage: messages?.onDeleteSuccessMessage,
            errorMessage: messages?.onDeleteErrorMessage,
        });
    }
}
